export const getAllOffers = state => {
  if (state.offers.response) {
    return state.offers.response;
  } else {
    return null;
  }
};
